import abstractAutoCompele from './abstract-autocomplete';
import editTimeSlotAddSlot from './edit-time-slot-add-slot';

export default function () {
    abstractAutoCompele();
    editTimeSlotAddSlot(); //this must be called after auto complete is inited
}